export default __webpack_public_path__ + "static/media/icon-redirect-3.409bfde2.svg";